<template>
  <div class="day-deal-wrap white section-gap" v-if="data.length">
    <v-container grid-list-xl pb-0>
      <v-layout row wrap>
        <v-flex xs12 sm12 md6 lg6 xl6>
          <router-link :to="detailPage(data[0].More_details_page_link)">
            <v-img
              alt="deal of the day"
              :src="selectedPreviewImage.Product_Image_626_x_800px"
              aspect-ratio="1"
              max-width="900"
              max-height="800"
            />
          </router-link>
        </v-flex>
        <v-flex xs12 sm12 md6 lg6 xl6 pl-5 deal-content>
          <div class="day-deal-content">
            <div class="mb-12">
              <h2 class="font-weight-regular mb-6">{{dealsection.Title}}</h2>
              <h5 class="font-weight-regular">{{data[0].Name}}</h5>
              <p class="d-inline-block mr-1" v-if="data[0].Discount_Percentage">
                <strike class="px-1">
                  <!-- <emb-currency-sign class="font-color"></emb-currency-sign> -->
                   {{$n(data[0].Price/selectCurrency.CurrencyMultiplier,'currency',selectCurrency.selectedCurrency)}}
                  <!-- {{data[0].Price}} -->
                </strike>
              </p>
              <p class="accent--text d-inline-block sec-content" v-if="data[0].Discount_Percentage">
                {{data.metaainfo}}
                <!-- <emb-currency-sign class="accent--text"></emb-currency-sign> -->
                {{$n(data[0].sellingPrice/selectCurrency.CurrencyMultiplier,'currency',selectCurrency.selectedCurrency)}}
                <!-- {{data[0].sellingPrice}} -->
              </p>
			  <p class="accent--text d-inline-block sec-content" v-if="!data[0].Discount_Percentage">
                {{data.metaainfo}}
                <!-- <emb-currency-sign class="accent--text"></emb-currency-sign> -->
                  {{$n(data[0].sellingPrice/selectCurrency.CurrencyMultiplier,'currency',selectCurrency.selectedCurrency)}}
                <!-- {{data[0].sellingPrice}} -->
              </p>
              <p v-html="data[0].Details"></p>
              <div class="timer mb-6">
                <emb-timer 
									class="mb-4"
									starttime="Dec 1, 2018 15:37:25" 
									endtime="Dec 25, 2025 16:37:25" 
									trans='{  
										"day":"Day",
										"hours":"Hours",
										"minutes":"Minutes",
										"seconds":"Seconds",
										"expired":"Event has been expired.",
										"running":"Till the end of event.",
										"upcoming":"Till start of event.",
										"status": {
											"expired":"Expired",
											"running":"Running",
											"upcoming":"Future"
										}
									}'
								>
								</emb-timer>
              </div>
              <!-- <v-btn color="accent" to="/products/men/103"> -->
              <v-btn color="accent" :to="detailPage(data[0].More_details_page_link)">{{dealsection.Shop_Now_Button}}</v-btn>
            </div>
            <v-layout row wrap cmx-0>
              <v-flex
                xs4
                sm4
                md4
                lg4
                xl4
                class="product-gallery"
                v-for="(productImage,key) in data[0].Product_Image_List.slice(0,3)"
                :key="key"
                @click="togglePreviewImage(productImage)"
              >
                <a href="javascript:void(0)">
                  <v-img
                    alt="deal of the day"
                    class="emb-card"
                    :src="productImage.Product_Image_626_x_800px"
                    aspect-ratio="0.8"
                    max-width="217"
                    max-height="217"
                  />
                </a>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["data", "dealsection"],
  data() {
    return {
      selectedPreviewImage: {},
       selectedCurrency: (localStorage.selectedCurrency) ? localStorage.selectedCurrency : 'AED',
      CurrencyMultiplier: (localStorage.CurrencyMultiplier) ? parseFloat(localStorage.CurrencyMultiplier) : parseFloat(1),
    };
  },
  created() {
    setTimeout(() => {
      this.imageload();
    }, 1000);
  },
  computed: {
    ...mapGetters(["selectCurrency"]),
  },
  methods: {
    /**
     * method to toggle the image
     */
    togglePreviewImage(image) {
      this.selectedPreviewImage = image;
    },
    imageload: function () {
      this.selectedPreviewImage = this.data[0].Product_Image_List[0];
	},
	detailPage(url) {
      if (url != "") {
        url = url.split("/Template/")[1];
        // url = url.split(" ").join("-");
        url = url.split(".").slice(0, -1).join(".");
        url = "/product-details?page=" + url;
      } else {
        url = "#";
      }
      return url;
    },
  },
  // 	mounted() {
  // 		var self =this;
  // 		if (typeof(self.selectedPreviewImage) == 'undefined') {
  //  self.selectedPreviewImage = self.data[0].Product_Image_List;
  // }
  //     }
};
</script>
